<template>
    <!-- 优势特点 -->
    <section class="home-advantages">
        <div class="home-advantages-title">
            <p>优势特点</p>
            <p>Advantage in</p>
        </div>
        <div class="home-advantages-content">
            <div class="content--item" :style="`background: url(${require('@/assets/webImg/advantages/bg1.png')}) 0 0 no-repeat;`">
                <img src="@/assets/webImg/advantages/qiye.png" alt="">
                <span class="content--item-sf">企业</span>
                <span class="content--item-sl">1天实现信息化管理效率翻5倍</span>
                <button>查看更多</button>
            </div>
            <div class="content--item" :style="`background: url(${require('@/assets/webImg/advantages/bg2.png')}) 0 0 no-repeat;`">
                <img src="@/assets/webImg/advantages/laoban.png" alt="">
                <span class="content--item-sf">老板</span>
                <span class="content--item-sl">用工风险全规避掌控企业大数据</span>
                <button>查看更多</button>
            </div>
            <div class="content--item" :style="`background: url(${require('@/assets/webImg/advantages/bg3.png')}) 0 0 no-repeat;`">
                <img src="@/assets/webImg/advantages/hr.png" alt="">
                <span class="content--item-sf">HR</span>
                <span class="content--item-sl">薪酬算薪更高效人事管理有依据</span>
                <button>查看更多</button>
            </div>
            <div class="content--item" :style="`background: url(${require('@/assets/webImg/advantages/bg4.png')}) 0 0 no-repeat;`">
                <img src="@/assets/webImg/advantages/yuangong.png" alt="">
                <span class="content--item-sf">员工</span>
                <span class="content--item-sl">考勤审批用微信员工自助上手快</span>
                <button>查看更多</button>
            </div>
        </div>
    </section>
</template>

<script>


export default {

	data() {
		return {}
	},

	computed: {},

	created() {},

    methods: {}

}
</script>

<style lang="scss" scoped>
/** 优势特点 */
.home-advantages {
    margin: 0 1.60rem;
    margin-top: 34px;

    .home-advantages-title {
        text-align: center;
        p:first-child {
            font-size: 40px;
            line-height: 56px;
            color: #363636;
        }
        p:last-child {
            font-size: 33px;
            color: #B5B5B5;
            line-height: 46px;
        }
    }

    .home-advantages-content {
        margin-top: 65px;
        display: flex;
        .content--item {
            position: relative;
            box-sizing: border-box;
            width: 400px;
            height: 690px;
            padding-top: 244px;
            background-size: cover;
            cursor: pointer;
            text-align: center;
            overflow: hidden;
            transition: all 0.2s linear;
            &::before {
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                top: 0;
                background-color: rgba(0, 0, 0, 0);
                z-index: 2;
                transition: all 0.2s linear;
            }

            img,span { display: inline-block; }
            span { width: 100%; }
            .content--item-sf {
                // margin-top: 20px;
                font-size: 40px;
                color: #FFFFFF;
                // line-height: 56px;
                
            }
            .content--item-sl {
                opacity: 0;
                width: 159px;
                // margin-top: 60px;
                font-size: 24px;
                color: #FFFFFF;
                line-height: 33px;
                transition: all 0.2s linear;
            }
            button {
                opacity: 0;
                margin-top: 75px;
                transition: all 0.2s linear;
            }
        }
        .content--item:hover {
            padding-top: 1.00rem;
            &::before {
                background-color: rgba(25, 96, 174, .5);
            }
            .content--item-sl,button {
                opacity: 1;
            }
        }

        button {
            display: block;
            margin: 0 auto;
            width: 172px;
            height: 56px;
            border-radius: 8px;
            border: 1px solid #FFFFFF;
            color: white;
            font-size: 24px;
            background-color: rgba(0, 0, 0, 0);
            outline: none;
        }

    }
}

</style>
